"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const chapters = [{
  id: "ch1",
  number: "01",
  title: "Introduction",
  content: <>
        These Terms and Conditions govern your access to and use of the <strong>KS Luxury Renovations</strong> website operated by <strong>KS Luxury Renovations LTD</strong>.
        {"\n\n"}By accessing, browsing or using this website, you agree to be bound by these Terms and Conditions. If you do not agree with them, you should not use the website.
      </>
}, {
  id: "ch2",
  number: "02",
  title: "About Us",
  content: <div className="whitespace-pre-line">
        This website is operated by:
        {"\n\n"}<strong>KS Luxury Renovations LTD</strong>
        {"\n"}<strong>Aisopou 17, Agios Nikolaos, 3100, Limassol</strong>
        {"\n"}Email: info@ltl.com.cy
        {"\n"}Phone: +357 97 673 308
        {"\n"}Company registration number: 10405651Q
      </div>
}, {
  id: "ch3",
  number: "03",
  title: "Use of the Website",
  content: <>
        You may use this website only for lawful purposes and in accordance with these Terms and Conditions.
        <ul className="list-disc ml-6 mt-4 space-y-2">
          <li>You must not use the website in any way that is unlawful, fraudulent, harmful or abusive.</li>
          <li>You must not attempt to gain unauthorised access to the website, the server on which it is hosted, or any connected system, database or network.</li>
          <li>You must not interfere with or disrupt the website's functionality or security.</li>
          <li>You must not knowingly introduce viruses, malware, malicious code or any material that is technologically harmful.</li>
        </ul>
      </>
}, {
  id: "ch4",
  number: "04",
  title: "Intellectual Property",
  content: <>
        Unless otherwise stated, all content on this website, including text, layout, graphics, logos, branding elements, photographs, renderings, downloads, design elements and other materials, is owned by or licensed to <strong>KS Luxury Renovations LTD</strong> and is protected by applicable intellectual property laws.
        {"\n\n"}You may view the website and print or download extracts for your personal, non-commercial use only. You may not reproduce, republish, distribute, modify, transmit, display or exploit any content from the website without our prior written consent, except where permitted by mandatory law.
      </>
}, {
  id: "ch5",
  number: "05",
  title: "Website Content and Property Information Disclaimer",
  content: <>
        The content on this website is provided for general information purposes only. While we make reasonable efforts to ensure that information is current and accurate, we do not guarantee that all content is complete, accurate, current or free from errors.
        {"\n\n"}In particular, any information regarding developments, projects, specifications, floor plans, layouts, imagery, dimensions, finishes, amenities, delivery timing, availability, pricing or status is indicative only and may be subject to change without notice.
        <ul className="list-disc ml-6 mt-4 space-y-2">
          <li>Architectural drawings, renders, visuals, photography and plans may be illustrative in nature.</li>
          <li>Project details, technical characteristics and finishes may change during design, construction or marketing stages.</li>
          <li>Nothing on the website constitutes a binding offer, reservation, guarantee or contractual commitment unless expressly set out in a signed written agreement.</li>
        </ul>
      </>
}, {
  id: "ch6",
  number: "06",
  title: "No Professional or Investment Advice",
  content: <>
        Nothing on this website constitutes legal, financial, tax, investment, technical or professional advice. Any decision to purchase, invest, reserve, contract or otherwise rely on information published on the website should be made only after obtaining appropriate independent advice and reviewing the relevant contractual documentation.
      </>
}, {
  id: "ch7",
  number: "07",
  title: "Enquiries and Communications",
  content: <>
        Submitting an enquiry through the website does not create any contractual relationship, reservation, exclusivity right or obligation on our part to provide a property, service or response within a specific timeframe. We reserve the right to respond, follow up or decline to proceed with any enquiry at our discretion and subject to availability.
      </>
}, {
  id: "ch8",
  number: "08",
  title: "Availability of the Website",
  content: <>
        We do not guarantee that the website, or any content on it, will always be available, uninterrupted, secure or error-free. We may suspend, withdraw, discontinue or change all or any part of the website without notice.
      </>
}, {
  id: "ch9",
  number: "09",
  title: "Limitation of Liability",
  content: <>
        To the fullest extent permitted by law, <strong>KS Luxury Renovations LTD</strong> excludes all representations, warranties and conditions in relation to the website and its content, whether express or implied.
        {"\n\n"}To the fullest extent permitted by law, we shall not be liable for any direct, indirect, incidental, consequential, special or punitive loss or damage arising out of or in connection with:
        <ul className="list-disc ml-6 mt-4 space-y-2">
          <li>your access to, use of, or inability to use the website</li>
          <li>reliance on any content published on the website</li>
          <li>technical problems, interruptions, delays, viruses or security incidents</li>
          <li>any actions taken or not taken based on website content</li>
        </ul>
        {"\n"}Nothing in these Terms and Conditions excludes or limits liability where such exclusion or limitation would be unlawful under applicable law.
      </>
}, {
  id: "ch10",
  number: "10",
  title: "Third-Party Links",
  content: <>
        This website may contain links to third-party websites or services for convenience or reference. We do not control and are not responsible for the availability, content, accuracy, privacy practices or terms of those third-party websites.
      </>
}, {
  id: "ch11",
  number: "11",
  title: "Privacy and Cookies",
  content: <>
        Use of the website is also subject to our Privacy Policy and Cookies Policy, which explain how we collect and process personal data and how cookies are used on the website.
      </>
}, {
  id: "ch12",
  number: "12",
  title: "Changes to the Website or Terms",
  content: <>
        We may update, amend or revise these Terms and Conditions at any time without prior notice. The version published on the website from time to time will apply to your use of the website.
      </>
}, {
  id: "ch13",
  number: "13",
  title: "Governing Law and Jurisdiction",
  content: <>
        These Terms and Conditions are governed by the laws of the Republic of Cyprus. Any dispute arising out of or in connection with these Terms and Conditions or the use of the website shall be subject to the exclusive jurisdiction of the courts of Cyprus, unless mandatory law provides otherwise.
      </>
}, {
  id: "ch14",
  number: "14",
  title: "Contact Us",
  content: <div className="whitespace-pre-line">
        If you have any questions regarding these Terms and Conditions, please contact:
        {"\n\n"}<strong>KS Luxury Renovations LTD</strong>
        {"\n"}Registered office:<strong> Aisopou 17, Agios Nikolaos, 3100, Limassol </strong>
        {"\n"}Email: ks@theksway.com
        {"\n"}Phone: +357 97 673 308
        {"\n"}<strong>Company registration number: 10405651Q</strong>
      </div>
}];
export default function BookContent() {
  return <section data-section-id="185128" id="full-terms" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="mt-8">
              <h1 className="font-default font-bold tracking-tight text-secondary !text-5xl">Terms and Conditions</h1>
              <span className="font-sans text-lg text-muted-foreground mt-4 block">
                Effective Date: April 2026
              </span>
            </div>

            <Separator className="my-8 bg-border" />

            <div className="space-y-12">
              {chapters.map((chapter, i) => <div key={chapter.id} data-index={i} className="py-4">
                  <span className="font-sans text-sm font-bold tracking-wider text-accent-dark">
                    {chapter.number}
                  </span>
                  <h2 className="font-default font-bold mt-2 text-secondary !text-4xl">
                    {chapter.title}
                  </h2>
                  <div className="font-sans text-base md:text-lg leading-relaxed mt-6 text-muted-foreground whitespace-pre-line">
                    {chapter.content}
                  </div>
                </div>)}
            </div>
          </div>
          
          <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
          </div>
        </div>
      </div>
    </section>;
}